import { createContext } from 'react';
export const defaultContext = {
    isDisabled: false,
    isFocused: false,
    isHovering: false,
    isSelected: false,
};
export const createInputStateContext = () => (createContext(defaultContext));
export const CheckboxInputStateContext = createInputStateContext();
export const RadioInputStateContext = createInputStateContext();
export const PickerOptionInputStateContext = createInputStateContext();
